import * as React from 'react';
import { filter, map, mean, round } from 'lodash';

const cell = (value: string|undefined) => value ? `${value}% Correct` : `--`;

const footerCell = (props: any) => {
  const arrayOfScores = filter(props.data, d => d[props.column.id] !== '--');

  if (! arrayOfScores.length) {
    return <span/>;
  }

  return <span>
    {round(mean(map(arrayOfScores, d => d['_original'][props.column.id])))}% Correct
  </span>;
};

const columns = [
  {
    Header: "Class Section",
    id: "name",
    accessor: (metric: any) => metric.name,
    minWidth: 200,
    Footer: <strong>Averages</strong>
  },
  {
    Header: "Pre-Test",
    id: "quiz.1.0",
    accessor: (metric: any) => cell(metric['quiz.1.0']),
    minWidth: 100,
    Footer: footerCell
  },
  {
    Header: "PE 1",
    id: "quiz.2.1",
    accessor: (metric: any) => cell(metric['quiz.2.1']),
    minWidth: 100,
    Footer: footerCell
  },
  {
    Header: "PE 2",
    id: "quiz.2.2",
    accessor: (metric: any) => cell(metric['quiz.2.2']),
    minWidth: 100,
    Footer: footerCell
  },
  {
    Header: "PE 3",
    id: "quiz.2.3",
    accessor: (metric: any) => cell(metric['quiz.2.3']),
    minWidth: 100,
    Footer: footerCell
  },
  {
    Header: "Post-Evaluation",
    id: "quiz.3.0",
    accessor: (metric: any) => cell(metric['quiz.3.0']),
    minWidth: 140,
    Footer: footerCell
  },
];

export default columns;
